import { render } from "./StreamingEnd.vue?vue&type=template&id=2f023932&scoped=true"
import script from "./StreamingEnd.vue?vue&type=script&lang=js"
export * from "./StreamingEnd.vue?vue&type=script&lang=js"

import "./StreamingEnd.vue?vue&type=style&index=0&id=2f023932&scoped=true&lang=css"

import exportComponent from "D:\\project\\weshow-front-rococo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f023932"]])

export default __exports__